import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { withTranslation } from "react-i18next";

class KnoaDropdownNav extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };

        this.onToggle = this.onToggle.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }

    onToggle(isOpen) {
        this.setState({ isOpen });
    }

    onMouseEnter() {
        this.setState({ isOpen: true });
    }

    onMouseLeave() {
        this.setState({ isOpen: false });
    }

    handleSelect(selectedId) {
        const selectedOption = this.props.options.find(opt => opt.id === selectedId);
        if (selectedOption && typeof selectedOption.onClick === "function") {
            selectedOption.onClick();
        }
    }

    render() {
        const { options, t } = this.props;
        const { isOpen } = this.state;

        return (
            <Dropdown
                show={isOpen}
                onToggle={this.onToggle}
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
                onSelect={this.handleSelect}
            >
                <Dropdown.Toggle
                    ref={this.props.setDropdownToggleRef}
                    id="knoaDropdown-more"
                    variant="default"
                    aria-haspopup="true"
                    aria-expanded={isOpen}
                    aria-controls="knoaDropdown-menu"
                    className={
                        isOpen
                            ? "dropdownNavContainer dropdownNavContainerShow"
                            : "dropdownNavContainer dropdownNavContainerHide"
                    }
                >
                    <span className="pressText navItemText">{t("common:more")}</span>
                </Dropdown.Toggle>

                <Dropdown.Menu id="knoaDropdown-menu" role="menu">
                    {options.map((option, index) =>
                        option.divider ? (
                            <Dropdown.Divider key={`divider-${index}`} />
                        ) : (
                            <Dropdown.Item
                                as={NavLink}
                                to={{
                                    pathname: option.href,
                                    state: {
                                        id: option.id,
                                        newProject: option.newProject || null,
                                        preSelectReportID: option.preSelectReportID || null
                                    }
                                }}
                                key={option.id}
                                className="knoaDropdownItem noPadding"
                                role="menuitem"
                                tabIndex="0"
                                onClick={option.onClick}
                                onKeyDown={(e) => {
                                    if (e.key === ' ' || e.key === 'Spacebar') {
                                        e.preventDefault(); // Prevent scroll
                                        e.target.click();   // Trigger navigation
                                    }
                                }}

                            >
                                <span className="pressText navItemText">{option.name}</span>
                            </Dropdown.Item>
                        )
                    )}
                </Dropdown.Menu>
            </Dropdown>
        );
    }
}

export default withTranslation()(KnoaDropdownNav);